import { render, staticRenderFns } from "./wasteWater.vue?vue&type=template&id=b9ed2a8a&scoped=true&"
import script from "./wasteWater.vue?vue&type=script&lang=js&"
export * from "./wasteWater.vue?vue&type=script&lang=js&"
import style0 from "./wasteWater.vue?vue&type=style&index=0&id=b9ed2a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ed2a8a",
  null
  
)

export default component.exports